import KickClient from "./api.js";
import {
  gtmTrackGAEvent,
  GA_CATEGORY_CONSULTATION,
} from "~/shared/utils/analytics";

const KICK_EVENT_VISIT_PRODUCT_SELECTED = "visitProductSelected";
const KICK_EVENT_VISIT_PHARMACY_SELECTED = "visitPharmacySelected";
const KICK_EVENT_VISIT_ABANDONED = "visitAbandoned";

const GA_CATEGORY_SIGNUP = "Signup";

export function trackKickEvent(visitID, eventName, detail, payload) {
  const visitEventsPath = "/visit-events";
  // get a token
  KickClient.newAuthenticatedClient()
    .post(visitEventsPath, {
      event: eventName,
      visitID: visitID,
      detail: detail,
      payload: payload,
    })
    .then((response) => {
      // console.log(response);
    })
    .catch((error) => {
      console.error("[trackKickEvent] Error: ", error);
    });
}

export function trackVisitProductSelected(visitID, productName) {
  trackKickEvent(visitID, KICK_EVENT_VISIT_PRODUCT_SELECTED, productName);
}
export function trackVisitPharmacySelected(visitID, pharmacyName, payload) {
  trackKickEvent(
    visitID,
    KICK_EVENT_VISIT_PHARMACY_SELECTED,
    pharmacyName,
    payload
  );
}
// export function trackVisitAbandoned(location) {
//   trackKickEvent(KICK_EVENT_VISIT_ABANDONED, location);
// }

export function trackConsultStart(service) {
  gtmTrackGAEvent(GA_CATEGORY_CONSULTATION, "Consult Started", service, 1);
}

